export default {
  calendar: {
    calendarCollapsed: false,
    selectedDate: null,
    isDataLoaded: false,
    isLoadingMoreDataFuture: false,
    isLoadingMoreDataPast: false
  },
  crops: {
    isDataLoaded: false
  },
  wishlist: {
    isDataLoaded: false
  }
}
